module.exports = __webpack_public_path__ + "static/media/photo.e8ec1a40.svg";